module.exports = __webpack_public_path__ + "static/icon-na-terrestre-78ce8f60ccdc1db6912b2a56af6aa681.svg";